import { render, staticRenderFns } from "./addAdvertisng.vue?vue&type=template&id=1b7b7234&"
import script from "./addAdvertisng.vue?vue&type=script&lang=js&"
export * from "./addAdvertisng.vue?vue&type=script&lang=js&"
import style0 from "./addAdvertisng.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports